export default __webpack_public_path__ + "static/media/emtec-inc.df29131f.png";